import * as http from "api/http";

import { SERVICES_URL, handleError } from "api/helper";

import { TaxInfo } from "api/models/taxServiceModels";

const taxBaseUrl = "api/v1/tax";
const get = http.get;

export const getTaxInfo = (officeId: string): Promise<TaxInfo> =>
  get(`${SERVICES_URL}/${taxBaseUrl}/${officeId}`).catch(handleError);
